module.exports = require("core-js/library/fn/object/keys");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/object/keys.js
// module id = ./node_modules/@babel/runtime/core-js/object/keys.js
// module chunks = 0